import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import {createAction as create} from 'redux-actions';

import * as types from './types';
import {PARAM_KEYS} from 'admin-ng/constants';
import {all} from 'admin-ng/api/api-keys';

export const fetchAction = create(types.FETCH);
export const fetch = () => async (dispatch, getState) => {
  dispatch(fetchAction({isFetching: true}));
  const params = pickBy(pick(getState().apiKeys, PARAM_KEYS));
  if (params.filters) {
    params.state__in = params.filters;
    delete params.filters;
  }
  try {
    const {
      body: {
        results: apiKeys,
        meta: {count: total},
      },
    } = await all(params);
    return dispatch(fetchAction({apiKeys, total}));
  } catch (err) {
    dispatch(fetchAction(err));
  }
};

export const setParams = create(types.SET_PARAMS);
export const reset = create(types.RESET);
